import React from 'react';

interface IGiactStatusPillProps {
  giactStatus?: string;
}

export const getGiactPillDetails = (giactStatus?: string) => {
  let color;
  switch (giactStatus) {
    case 'Pass':
    case 'Pass Non-Demand Deposit':
      color = 'bg-green-100 text-green-800';
      break;
    case 'Accept with Risk':
    case 'Risk Alert':
    case 'Negative Data':
      color = 'bg-yellow-100 text-yellow-800';
      break;
    case 'Error':
    case 'Private Bad Check List':
    case 'Declined':
    case 'Reject Item':
    case 'No Data':
    case 'Not Applicable':
      color = 'bg-red-100 text-red-800';
      break;
    default:
      throw new Error(`Unexpected GIACT status: ${giactStatus}`);
  }
  return { color, text: giactStatus };
};

export const GiactStatusPill: React.FC<IGiactStatusPillProps> = ({ giactStatus }) => {
  const values = getGiactPillDetails(giactStatus);
  return (
    <span
      data-test-id={`giact-status-pill`}
      className={`${values.color} ml-2 h-fit w-fit whitespace-nowrap rounded-full px-2 py-1 align-middle text-xs font-medium`}
    >
      {values.text}
    </span>
  );
};
